import { useState } from "react";
import { useParams } from "react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import NiceModal from "@ebay/nice-modal-react";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import BrandLogo from "@components/BrandLogo";
import wheel from "./img/wheel.svg";
import { awards } from "./awards/awards";
import { whellSpin } from "../../../../../api/activation";
import indicator from "./img/indicator.svg";
import shade from "./img/shade.svg";
import veloLogo from "./img/velo-logo.svg";
import DOMPurify from "dompurify";

const WheelItem = ({
  spin,
  handleFinishSpin,
  style,
  setGradientLevel,
  beforeSpin,
}) => {
  return (
    <div className="wheel">
      <img src={shade} className="shade" />
      <img
        className={spin ? "wheel-image spin" : "wheel-image before-spin"}
        onTransitionEnd={() => {
          setTimeout(() => {
            handleFinishSpin();
          }, 1100);
        }}
        style={style}
        src={wheel}
        alt="koło"
      />

      <img src={veloLogo} className="logo" />
      <div className={spin ? "indicator active" : "indicator"}>
        <img src={indicator} alt="wskaźnik" />
      </div>
    </div>
  );
};

export default function Wheel({ currentQuestion }) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;

  const [deg, setDeg] = useState(0);
  const [beforeSpin, setBeforeSpin] = useState(5);
  const [drawnPrize, setDrawnPrize] = useState(null);
  const [spin, setSpin] = useState(false);

  const [showCongratulation, setShowCongratulation] = useState(false);

  // const singlePrizeDeg = 60;
  const singlePrizeDeg = 30;
  const spinNumberBeforeStart = 5;
  const wholeSpin = 360 * spinNumberBeforeStart;

  const style = {
    transform: `rotate(${deg}deg)`,
    transition: deg === 0 ? "none" : "all 4s cubic-bezier(.42,0,.44,1.05)",
  };

  const handleStartSpine = (prizeNumber) => {
    setSpin(true);
    const needToSpin =
      prizeNumber == 0 ? wholeSpin : wholeSpin + prizeNumber * singlePrizeDeg;
    setDeg(needToSpin);
  };

  const successCallback = ({ data }) => {
    let award = data?.catalogue ?? data?.activation;

    if (award === null) {
      setDeg(-80);
      setDrawnPrize(awards["lose"]);
      handleStartSpine(awards["lose"].prizeNumber);
    } else {
      setDeg(-80);
      setDrawnPrize(awards[award]);
      handleStartSpine(awards[award].prizeNumber);
      console.log(awards[award].prizeNumber);
    }
  };

  const handleFinishSpin = () => {
    NiceModal.show("wheel-prize-modal", {
      prize: drawnPrize?.content,
      callback: () => {
        setShowCongratulation(true);
      },
    });

    setSpin(false);
  };
  const fakeFetch = () => {
    queryClient.fetchQuery({
      queryKey: ["wheel-spin-data"],
      queryFn: () =>
        whellSpin({
          successCallback,
          payload: {},
        }),
      retry: false,
      cacheTime: Infinity,
      staleTime: 1000 * 60 * 3,
    });
  };

  return (
    <section className={`game-page wheel-mechanics ${ident}`}>
      <div>
        <PagesHeader>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>

        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <div className="game-question">
              {gameQuestionsQuery?.content[currentQuestion].header && (
                <p
                  className="question-header"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(gameQuestionsQuery?.content[currentQuestion].header),
                  }}
                />
              )}
              <div className="how-to-box">
                <h2
                  className="question"
                  dangerouslySetInnerHTML={{
                    __html:
                      DOMPurify.sanitize(gameQuestionsQuery?.content[currentQuestion].question),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="side-img">
            <div className="whell-wrapper">
              <img className="bg" src={gameQuestionsQuery?.mainImage} />
              <WheelItem
                gradient
                spin={spin}
                handleFinishSpin={handleFinishSpin}
                style={style}
              />
            </div>

            <BrandLogo brands={["glo"]} />

            {XGA && (
              <div className="desktop-buttons-1">
                <Button
                  disabled={false}
                  action={() => {
                    fakeFetch();
                  }}
                >
                  Jetzt drehen
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton
          action={() => {
            fakeFetch();
          }}
        >
          <div className="inner">Jetzt drehen</div>
        </StickyButton>
      )}
    </section>
  );
}
